import { type Dispatch, type SetStateAction, useState } from 'react'
import { type ArchivedFilter, type RoleData, searchIncludes } from '@terros/common'
import { type RoleList } from '../types'
import { type GetHookResponse } from '../hooks'
import { useRoles } from './list'

export type RoleListState = GetHookResponse<RoleList> & {
  filtered: RoleList
  filter: string
  setFilter: Dispatch<SetStateAction<string>>
  showArchived: ArchivedFilter
  setShowArchived: Dispatch<SetStateAction<ArchivedFilter>>
}

const idSearchKey = (value: string): string => (value.includes('.') ? value.slice(value.indexOf('.') + 1) : value)

export const filterRoles = <T extends Pick<RoleData, 'name' | 'roleId'>>(roles: T[], filter: string): T[] =>
  roles.filter(
    (role) => searchIncludes([role.name], filter) || searchIncludes([idSearchKey(role.roleId)], idSearchKey(filter))
  )

export function useRoleListState(showArchivedByDefault?: boolean): RoleListState {
  const [filter, setFilter] = useState('')
  const [showArchived, setShowArchived] = useState<ArchivedFilter>(Boolean(showArchivedByDefault))
  const state = useRoles({ showArchived })
  const roles = state.data ?? []
  const filteredRoles = filterRoles(roles, filter)

  return {
    ...state,
    filtered: filteredRoles,
    filter,
    setFilter,
    showArchived,
    setShowArchived,
  }
}
